import React from 'react'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'
import { Text } from '@pandiafi/components'

import { ExtraServiceReservationsDataLoader } from './ExtraServiceReservationsDataLoader'
import { generateExtraServiceReservationName } from './extraServiceReservationNaming.util'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'
import { ExtraServiceReservationPincode } from './ExtraServiceReservationPincode'

type ExtraServiceReservationsListProps = {
  type: 'storage' | 'right_of_access'
}

export const ExtraServiceReservationsList: React.FC<
  ExtraServiceReservationsListProps
> = ({ type }) => {
  const { t, i18n } = useTranslation(['storage', 'gymBooking', 'reservations'])
  const { currentContractId } = useCurrentContract()

  return (
    <ExtraServiceReservationsDataLoader type={type}>
      {(extraServiceReservations) => {
        return (
          extraServiceReservations.length > 0 && (
            <div className="space-y-1">
              <Text element="div" size="l" weight="bold">
                {t('reservations:myReservations')}
              </Text>

              <div>
                {extraServiceReservations.map((reservation) => {
                  const { name, needsGymPrefix } =
                    generateExtraServiceReservationName(reservation, type)

                  const gymTitle = needsGymPrefix
                    ? (t('gymBooking:reservation.title') as string)
                    : ''
                  const title = needsGymPrefix
                    ? name
                      ? `${gymTitle}, ${name}`
                      : gymTitle
                    : name

                  return (
                    <div key={reservation.id} className="mb-4">
                      <div>{title}</div>
                      <div>
                        {t('storage:extraService.startDate')}:{' '}
                        {DateTime.fromISO(reservation.startDate).toFormat(
                          'dd.MM.yyyy',
                          { locale: i18n.language }
                        )}
                      </div>
                      {reservation.endDate ? (
                        <div>
                          {t('storage:extraService.endDate')}:{' '}
                          {DateTime.fromISO(reservation.endDate).toFormat(
                            'dd.MM.yyyy',
                            { locale: i18n.language }
                          )}
                        </div>
                      ) : (
                        <div>{t('storage:extraService.openEnded')}</div>
                      )}
                      {reservation.hasLockAccess && (
                        <ExtraServiceReservationPincode
                          contractUuid={currentContractId}
                          contractPartId={reservation.id}
                        />
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
          )
        )
      }}
    </ExtraServiceReservationsDataLoader>
  )
}
